<template>
  <div class="konwledge-container">
    <iframe
      :src="jumpUrl"
      frameborder="0"
      class="knowledge-iframe"
      width="100%"
      height="100%"
    ></iframe>
    <div class="icon-container">
      <div class="icon-item">
        <img
          src="@/assets/home.png"
          alt=""
          class="home-icon"
          @click="jumpToHome"
        />
        <span>首页</span>
      </div>
      <div class="icon-item">
        <img
          src="@/assets/AI@2x.png"
          alt=""
          class="AI-helper"
          @click="toggleShowAI"
        />
        <span>招小科</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {};
  },
  computed: {
    jumpUrl() {
      return (
        this.$store.state.aiChat.knowledgeUrl + this.$store.state.aiChat.token
      );
    },
  },
  methods: {
    jumpToHome() {
      this.$router.push({
        path: "/research-visualization-full",
      });
    },
    toggleShowAI() {
      this.$parent.toggleShowAI();
    },
  },
};
</script>

<style lang="less" scoped>
.konwledge-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .icon-container {
    position: absolute;
    top: 7%;
    right: 18vw;
    display: flex;
    flex-direction: row;
    .icon-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 8px;
      span {
        color: #fff;
        font-size: 12rpx;
      }
    }
    .AI-helper {
      width: 40%;
      cursor: pointer;
    }
    .home-icon {
      width: 45%;
      cursor: pointer;
    }
  }
}
</style>
